const _excluded = ["children", "title", "subtitle", "actions", "titleContainerClassName", "titleClassName", "titleSmall", "cardStyle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
const DashCard = _ref => {
  let {
      children,
      title,
      subtitle,
      actions,
      titleContainerClassName = '',
      titleClassName = '',
      titleSmall = false,
      cardStyle = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    style: _objectSpread({
      borderRadius: '1.5rem'
    }, cardStyle)
  }), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "d-md-flex ".concat(titleContainerClassName)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card.Title, {
    className: "dashboard-card-title ".concat(titleSmall ? 'dashboard-card-title-small' : '', " ").concat(titleClassName),
    tag: "h4"
  }, title), /*#__PURE__*/React.createElement(Card.Text, {
    className: "text-muted"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "ms-auto mt-3 mt-md-0"
  }, actions)), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, children)));
};
DashCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node
};
export default DashCard;